if (!customElements.get('product-media-gallery-mobile-modal')) {
  customElements.define('product-media-gallery-mobile-modal', class ProductMediaGalleryMobileModal extends HTMLElement {
    constructor() {
      super();

      this.triggers = document.querySelectorAll('[data-product-media-gallery-mobile-modal-trigger]');
      this.closeButton = this.querySelectorAll('[data-product-media-gallery-mobile-modal-close]');
      this.carousel = this.querySelector('.product-media-gallery-mobile-modal__carousel');
      this.slides = this.querySelectorAll('.product-media-gallery-mobile-modal__slide');
      this.dots = this.querySelectorAll('.product-media-gallery-mobile-modal__dot');
      this.activeIndex = 0;
      this._onGesture = (event) => event.preventDefault();
    }

    connectedCallback() {
      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', this.openModal.bind(this));
      });

      this.closeButton.forEach(button => {
        button.addEventListener('click', this.closeModal.bind(this));
      });

      if (this.carousel) {
        this.carousel.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      }
    }

    openModal(event) {
      const clickedEl = event.currentTarget;
      const mediaId = clickedEl.dataset.mediaId;

      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      this.lockPageZoom(true);

      this.scrollToMedia(mediaId, false);
      this.setupPinchZoomForIndex(this.activeIndex);
    }

    closeModal() {
      this.resetPinchZoom(this.activeIndex);
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      this.lockPageZoom(false);
    }

    lockPageZoom(lock) {
      const viewport = document.querySelector('meta[name="viewport"]');

      if (lock) {
        document.addEventListener('gesturestart', this._onGesture, { passive: false });
        document.addEventListener('gesturechange', this._onGesture, { passive: false });

        if (viewport) {
          this._previousViewport = viewport.getAttribute('content');
          viewport.setAttribute(
            'content',
            'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
          );
        }
      } else {
        document.removeEventListener('gesturestart', this._onGesture);
        document.removeEventListener('gesturechange', this._onGesture);

        if (viewport && this._previousViewport) {
          viewport.setAttribute('content', this._previousViewport);
          this._previousViewport = null;
        }
      }
    }

    scrollToMedia(mediaId, smooth) {
      if (!this.carousel) return;

      let targetIndex = 0;
      this.slides.forEach((slide, i) => {
        if (slide.dataset.mediaId === mediaId) targetIndex = i;
      });

      const slideWidth = this.carousel.offsetWidth;
      this.carousel.scrollTo({
        left: slideWidth * targetIndex,
        behavior: smooth ? 'smooth' : 'instant'
      });
      this.setActiveIndex(targetIndex);
    }

    onScroll() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => {
        const scrollLeft = this.carousel.scrollLeft;
        const slideWidth = this.carousel.offsetWidth;
        const index = Math.round(scrollLeft / slideWidth);
        if (index !== this.activeIndex) {
          this.resetPinchZoom(this.activeIndex);
          this.setActiveIndex(index);
          this.setupPinchZoomForIndex(index);
        }
      });
    }

    setActiveIndex(index) {
      this.activeIndex = index;
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    getSlideImage(index) {
      const slide = this.slides[index];
      if (!slide) return null;
      return slide.querySelector('img');
    }

    setupPinchZoomForIndex(index) {
      const img = this.getSlideImage(index);
      if (!img || img._pz || typeof PinchZoom === 'undefined') return;

      const init = () => {
        if (img._pz) return;

        const pz = new PinchZoom.default(img, {
          draggableUnzoomed: false,
          minZoom: 1,
          maxZoom: 4,
          tapZoomFactor: 2
        });

        img._pz = pz;
      };

      if (img.complete) {
        init();
      } else {
        img.addEventListener('load', init, { once: true });
      }
    }

    resetPinchZoom(index) {
      const img = this.getSlideImage(index);
      if (!img || !img._pz) return;

      const pz = img._pz;
      const center = {
        x: pz.container.offsetWidth / 2,
        y: pz.container.offsetHeight / 2
      };
      pz.scaleTo(1, center);
      pz.offset = pz.sanitizeOffset(pz.initialOffset || { x: 0, y: 0 });
      pz.update();
    }
  });
}
